var _path, _path2, _path3, _path4, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpdate = function SvgUpdate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M9.5 26c-.382-3.468-.752-5.204-1.86-6.249C6.53 18.707 4.683 18.36 1 18c3.684-.36 5.53-.707 6.64-1.751S9.117 13.468 9.5 10c.382 3.467.752 5.204 1.86 6.249C12.47 17.293 14.317 17.64 18 18c-3.684.36-5.53.707-6.64 1.751S9.883 22.532 9.5 26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    d: "M22.5 12c-.202-2.167-.398-3.253-.985-3.905C20.928 7.442 19.95 7.225 18 7c1.95-.225 2.927-.442 3.515-1.095.587-.652.783-1.738.985-3.905.202 2.167.398 3.253.985 3.905.587.653 1.564.87 3.515 1.095-1.95.225-2.927.442-3.515 1.095-.587.652-.783 1.738-.985 3.905M62.5 48c-.292-2.817-.575-4.229-1.423-5.077S58.817 41.792 56 41.5c2.817-.292 4.229-.575 5.077-1.423S62.208 37.817 62.5 35c.292 2.817.575 4.229 1.423 5.077S66.183 41.208 69 41.5c-2.817.292-4.229.575-5.077 1.423S62.792 45.183 62.5 48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F68D1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M52.343 29.19a17.343 17.343 0 0 0-29.606-12.263M17.657 29.19a17.343 17.343 0 0 0 29.606 12.263"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F68D1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m46.302 24.533 6.04 4.657L57 23.149M23.698 33.335l-6.04-4.657L13 34.718"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60.714,
    height: 8,
    x: 4.5,
    y: 56.5,
    stroke: "#2F68D1",
    opacity: 0.75,
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 56.571,
    height: 3.857,
    x: 6.571,
    y: 58.571,
    fill: "#B4CFFF",
    rx: 1.929
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 3.857,
    x: 6.571,
    y: 58.571,
    fill: "#2F68D1",
    rx: 1.929
  })));
};
export default SvgUpdate;